<template>
  <div class="block">
    <template v-if="items">
      <p v-if="title" class="mainTitle">{{ title }}</p>
      <div class="inner">
        <OneWithSix :items="items"></OneWithSix>
      </div>
    </template>
  </div>
</template>

<script>
import OneWithSix from "./oneWithSix.vue";

export default {
  name: "OneLeftSixRight",
  components: {
    OneWithSix,
  },
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      title: "",
    };
  },
};
</script>